import { Box, Chip, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const getStatusColor = (status) => {
    switch (status) {
        case "Pending Approval":
        case "Awaiting RM Approval":
        case "Pending":
        case "Awaiting Second Approval":
        case "Awaiting Third Approval":
            return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
        case "Approved":
            return { bg: "#E8F5E9", text: "#66BB6A" }; // green
        case "Rejected":
        case "Cancelled":
            return { bg: "#FFEBEE", text: "#EF5350" }; // red
        case "Submitted":
            return { bg: "#E3F2FD", text: "#42A5F5" };
        default:
            return { bg: "#E5E7EB", text: "#374151" }; // gray
    }
};

export const MprStatusRenderer = ({ rowData }) => {
    const { bg, text } = getStatusColor(rowData?.mpr_status);
    
    const mpr_metadata_json = rowData?.mpr_metadata_json;
    const { bg: bg1, text: text1 } = getStatusColor(mpr_metadata_json?.first_status);
    const { bg: bg2, text: text2 } = getStatusColor(mpr_metadata_json?.second_status);
    const { bg: bg3, text: text3 } = getStatusColor(mpr_metadata_json?.third_status);

    const firstApprovalContent = (mpr_metadata_json?.first_status && rowData?.approver_name && rowData?.approver_id) ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', color: '#ccc' }}>
                    1. {rowData?.approver_name}:
                </Typography>
                <Chip
                    label={mpr_metadata_json?.first_status}
                    size="small"
                    sx={{ height: 16, fontSize: '9px', fontWeight: 600, backgroundColor: bg1, color: text1 }}
                />
            </Box>
            {mpr_metadata_json?.first_comment && (
                <Typography
                    variant="caption"
                    sx={{ fontSize: "10px", color: "#ccc", pl: 1.5 }}
                >
                    Comment:{" "}
                    <Box component="span" sx={{ color: "#fff" }}>
                        {mpr_metadata_json?.first_comment}
                    </Box>
                </Typography>
            )}
        </Box>
    ) : null;

    const secondApprovalContent = (mpr_metadata_json?.second_status && rowData?.second_approver_emp_name && rowData?.second_approver_employee_id) ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 1, mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', color: '#ccc' }}>
                    2. {rowData?.second_approver_emp_name}:
                </Typography>
                <Chip
                    label={mpr_metadata_json?.second_status}
                    size="small"
                    sx={{ height: 16, fontSize: '9px', fontWeight: 600, backgroundColor: bg2, color: text2 }}
                />
            </Box>
            {mpr_metadata_json?.second_comment && (
                <Typography
                    variant="caption"
                    sx={{ fontSize: "10px", color: "#ccc", pl: 1.5 }}
                >
                    Comment:{" "}
                    <Box component="span" sx={{ color: "#fff" }}>
                        {mpr_metadata_json?.second_comment}
                    </Box>
                </Typography>
            )}
        </Box>
    ) : null;

    const thirdApprovalContent = (mpr_metadata_json?.third_status && rowData?.third_approver_emp_name && rowData?.third_approver_employee_id) ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: 1, mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', color: '#ccc' }}>
                    3. {rowData?.third_approver_emp_name}:
                </Typography>
                <Chip
                    label={mpr_metadata_json?.third_status}
                    size="small"
                    sx={{ height: 16, fontSize: '9px', fontWeight: 600, backgroundColor: bg3, color: text3 }}
                />
            </Box>
            {mpr_metadata_json?.third_comment && (
                <Typography
                    variant="caption"
                    sx={{ fontSize: "10px", color: "#ccc", pl: 1.5 }}
                >
                    Comment:{" "}
                    <Box component="span" sx={{ color: "#fff" }}>
                        {mpr_metadata_json?.third_comment}
                    </Box>
                </Typography>
            )}
        </Box>
    ) : null;

    const tooltipText = (firstApprovalContent || secondApprovalContent || thirdApprovalContent) ? (
        <Box sx={{ p: 0.5 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, fontSize: '11px', color: '#fff' }}>
                Approval Workflow:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                {firstApprovalContent}
                {secondApprovalContent}
                {thirdApprovalContent}
            </Box>
        </Box>
    ) : null;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
                label={rowData?.mpr_status}
                style={{
                    backgroundColor: bg,
                    color: text,
                    fontWeight: 500,
                }}
                size="small"
            />
            {!(rowData?.mpr_status === "Cancelled") && (
                <Tooltip title={tooltipText || ""} arrow>
                    <InfoOutlinedIcon
                        fontSize="small"
                        color="action"
                        style={{ cursor: "pointer" }}
                    />
                </Tooltip>
            )}
        </Box>
    );
};